import React, { useState, useEffect } from 'react';

import Toggle from 'react-toggle';
import Toast from '../../components/Toast';
import UsersList from './UsersList';
import Modal from '../Modal';
import Button from '../Button';
import IconAdd from '../../icons/rev_add_user.png';
import FormInput from '../FormInput';
import SelectCheckbox from '../SelectCheckbox';
import UserAddEdit from '../../components/AddEditItems/UserAddEdit';
import DriverLicenseScanner from '../DriverLicenseScanner';
import CaretIcon from '../../icons/caret.png';
import Tick from '../../icons/rev_confirm.png';
import DeleteIcon from '../../icons/rev_delete.png';

import { getLoginDetails } from '../../utils/storage';

import useIsMobile from '../../hooks/useIsMobile';

// import ImageUploader from 'react-images-upload';

// import ImageUploading from "react-images-uploading";
import {
  STATES_LIST,
  postData,
  uploadFile,
  ADD_USERS_URL,
  FILE_UPLOAD_URL,
  GET_ROLES_URL,
  getData,
} from '../../utils/api';
import ImageUploading from './ImageUpload';

// const STATES = [ 'Florida', 'Wisconsin', 'Georgia'];
const userModel = {
  email: '',
  companyId: '',
  roleId: '',
  password: '',
  firstName: '',
  lastName: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  zipcode: '',
  profileUrl: '',
  smsNumber: '',
  notes: '',
  isActive: true,
};

const PARTNER_TYPES = [
  {
    id: 'YES',
    value: 'YES',
  },
  {
    id: 'NO',
    value: 'NO',
  },
];
const COMPANY_TYPES = [
  /*{
    id: "BUYER",
    value: "Partner Buyer",
  },
  {
    id: "COLLECTOR",
    value: "Partner Collector",
  },
  {
    id: "SI",
    value: "Seller Individual",
  },
  {
    id: "VIEWER",
    value: "VIEWER",
  },*/
  {
    id: 'SELLER',
    value: 'Partner Seller',
  },
  {
    id: 'FRANCHISE',
    value: 'Franchise',
  },
];

const COMPANY_TYPES_10 = [
  {
    id: 'SELLER',
    value: 'Partner Seller',
  },
];

const normalizeInput = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (value.length > 0) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
    return `${currentValue.slice(0, 3)}-${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

const EntityAddEdit = ({
  item,
  onClose,
  onSave,
  type,
  onBack,
  shouldShowPriceMod,
  facilities,
  editType,
  setRemoveTabs,
  isFromCart = false,
  isLoading = false,
  history,
  hideCustomers = false,
}) => {
  const loginDetails = getLoginDetails();
  const {
    hierarchy,
    canShowPriceModifier,
    canEditCompanyName,
    canAdjustCustomerSettings,
    canCreateFranchise,
    isAdmin,
    isFranchise,
    email: loginEmail,
    userEmail: loginUserEmail,
  } = loginDetails;
  
  // Use email or userEmail from login details
  // Also check for alternative property names or search for email in the object
  let userEmail = loginEmail || loginUserEmail;
  
  // If email not found, try to find it in nested objects or other properties
  if (!userEmail) {
    // Check nested user object
    if (loginDetails?.user?.email) {
      userEmail = loginDetails.user.email;
    }
    // Search recursively for any property containing an email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const findEmailInObject = (obj) => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (typeof value === 'string' && emailRegex.test(value)) {
            return value;
          }
          if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            const found = findEmailInObject(value);
            if (found) return found;
          }
        }
      }
      return null;
    };
    const emailValue = findEmailInObject(loginDetails || {});
    if (emailValue) {
      userEmail = emailValue;
    }
  }
  const pathname = window.location.pathname;
  
  // Allowed emails who can see Lookup Restrictions dropdown
  const allowedEmailsForLookupRestrictions = [
    'admin@abcattech.com',
    'brad@abcattech.com',
    'Grader1@abcattech.com',
    'chris@abcattech.com',
  ].map(email => email.toLowerCase());
  
  const canSeeLookupRestrictions = userEmail && allowedEmailsForLookupRestrictions.includes(userEmail.toLowerCase());
  
  // Debug logging (can be removed later)
  console.log('Lookup Restrictions Debug:', {
    userEmail,
    email: loginDetails.email,
    userEmailFromLogin: loginDetails.userEmail,
    allKeys: Object.keys(loginDetails),
    allLoginDetails: loginDetails,
    hierarchy,
    canSeeLookupRestrictions,
    allowedEmailsForLookupRestrictions
  });

  const isMobile = useIsMobile();

  /////edit state
  const [companyEditName, setEditCompanyName] = useState(undefined);
  const [editCompanyType, setEditCompanyType] = useState(undefined);
  const [editAddress, setEditAddress] = useState(undefined);
  const [editAddress1, setEditAddress1] = useState(undefined);
  const [editCity, setEditCity] = useState(undefined);
  const [editState, setEditState] = useState(undefined);
  const [editZipcode, setEditZipcode] = useState(undefined);
  const [editfacility, setEditFacility] = useState(undefined);
  const [editEmail, setEditEmail] = useState(undefined);
  const [editPhone, setEditPhone] = useState(normalizeInput(undefined));
  const [editDriversLicense, setEditDriversLicense] = useState(undefined);
  const [editFirstName, setEditFirstName] = useState(undefined);
  const [editLastName, setEditLastName] = useState(undefined);
  const [editBusinessLicense, setEditBusinessLicense] = useState(undefined);
  const [editIsPriceModifierPercantage, setEditIsPriceModifierPercantage] =
    useState(undefined);
  const [editCanSeeMarkup, setEditCanSeeMarkup] = useState(undefined);
  const [editCanBuildCart, setEditCanBuildCart] = useState(undefined);
  const [editIsAutoApproved, setEditIsAutoApproved] = useState(undefined);
  const [editIsCreditUnlimited, setEditIsCreditUnlimited] = useState(undefined);
  const [editCanSeeSubtotal, setEditCanSeeSubtotal] = useState(undefined);
  const [editEin, setEditEin] = useState(undefined);
  const [editPriceMod, setEditPriceMod] = useState(undefined);
  const [editIsPictureMandatory, setEditIsPictureMandatory] =
    useState(undefined);
  const [editCanSeeUnitPrice, setEditCanSeeUnitPrice] = useState(undefined);
  const [editImage, editSetImage] = useState(undefined);
  const [editModifierInputValue, setEditModifierInputValue] =
    useState(undefined);
  ///////
  const [companyName, setCompanyName] = useState(item?.companyName);
  const [companyType, setCompanyType] = useState(item?.companyType);
  const [address, setAddress] = useState(item?.address);
  const [address1, setAddress1] = useState(item?.address1);
  const [city, setCity] = useState(item?.city);
  const [state, setState] = useState(item.state);
  const [zipcode, setZipcode] = useState(item.zipcode);
  const [facility, setFacility] = useState(item.facility);
  const [lookupRestrictions, setLookupRestrictions] = useState(item?.lookupRestriction?.toString() || '');
  const [email, setEmail] = useState(item.email);
  const [phone, setPhone] = useState(normalizeInput(item.phone || ''));
  const [driversLicense, setDriversLicense] = useState(item.driversLicense);
  const [firstName, setFirstName] = useState(item.firstName);
  const [lastName, setLastName] = useState(item.lastName);
  const [showScanner, setShowScanner] = useState(false);
  const [isActive, setIsActive] = useState(item.isActive);
  const [isPictureMandatory, setIsPictureMandatory] = useState(
    item.isPictureMandatory || false
  );
  const [canSeeUnitPrice, setCanSeeUnitPrice] = useState(
    item.canSeeUnitPrice || false
  );
  const [canSeeMarkup, setCanSeeMarkup] = useState(item.canSeeMarkup || false);
  const [canSeeSubtotal, setCanSeeSubtotal] = useState(
    item.canSeeSubtotal || false
  );
  const [isAddPopupShown, setIsAddPopupShown] = useState(false);
  const [isShowUserDetails, setIsShowUserDetails] = useState(false);

  const [isPartner, setIsPartner] = useState(item.isPartner);
  const [priceMod, setPriceMod] = useState(item.priceMod);
  const [businessLicense, setBusinessLicense] = useState(item.businessLicense);
  const [ein, setEin] = useState(item.ein);
  const [selectedFacilities, setSelectedFacilities] = useState(
    (item.facilities || []).map((facility) => {
      const referenceFacility = facilities.find((refFacility) => {
        return facility === refFacility.facilityId;
      });
      return {
        id: (referenceFacility || {}).facilityId,
        value: (referenceFacility || {}).name,
      };
    })
  );

  const hideAbcPricing = true;

  const [image, setImage] = useState(null);

  const [metalLicense, setMetalLicense] = useState(item.metalLicense);

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const [canBuildCart, setCanBuildCart] = useState(item.canBuildCart || false);
  const [isAutoApproved, setIsAutoApproved] = useState(
    item.isAutoApproved || false
  );
  const [isCreditUnlimited, setIsCreditUnlimited] = useState(item.isCreditUnlimited || false);
  const [rolesItems, setRolesItems] = useState([]);

  const [validations, setValidations] = useState({});
  const [isPriceModifierPercantage, setIsPriceModifierPercantage] = useState(
    item.groupModifierIsPercentage
  );
  const [modifierInputValue, setModifierInputValue] = useState(
    item.groupModifier || ''
  );
  const validateFields = () => {
    const updatedValidations = { ...validations };

    // Company Name: minimum 3 characters
    updatedValidations.companyName = companyName && companyName.trim().length >= 3;
    // Email validation: must be present and in valid format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    updatedValidations.email = email && email.trim() && emailRegex.test(email.trim());
    updatedValidations.companyType = companyType;
    updatedValidations.address = address;
    updatedValidations.driversLicense = driversLicense; // Make driver license mandatory
    // updatedValidations.address1 = address1;
    // updatedValidations.phone = phone;
    updatedValidations.city = city;
    updatedValidations.state = state;
    updatedValidations.zipcode = zipcode;
    // First Name: minimum 2 characters
    updatedValidations.firstName = firstName && firstName.trim().length >= 2;
    // Last Name: minimum 2 characters
    updatedValidations.lastName = lastName && lastName.trim().length >= 2;
    updatedValidations.facility = companyType === 'FRANCHISE' ? '' : facility;

    setValidations(updatedValidations);
    return updatedValidations;
  };
  const [toastParams, setToastParams] = useState({
    message: '',
    type: '',
    id: '',
  });
  const [toastParams2, setToastParams2] = useState({
    message2: '',
    type2: '',
    id2: '',
  });

  const addItem = async (data, image) => {
    try {
      const body = {
        ...data,
        companyId: item.companyId,
        hierarchy,
        isAdmin,
        isFranchise,
      };
      if (image) {
        const response = await uploadFile(FILE_UPLOAD_URL, image.file);
        body.profileUrl = response.imageUrl;
      }
      const response = await postData(ADD_USERS_URL, body);
      setToastParams2({
        type2: 'SUCCESS',
        message2: 'Successfully added the User',
        id2: new Date().getTime(),
      });
      setIsAddPopupShown(false);
    } catch (e) {
      console.log('ERROR');
      setToastParams({
        type: 'ERROR',
        message:
          e && e.error
            ? e.error
            : 'Oops! Something went wrong. Please try again later',
        id: new Date().getTime(),
      });
    }
  };

  useEffect(() => {
    getRolesAndPermissions();
  }, []);

  const getRolesAndPermissions = async () => {
    try {
      const data = await getData(GET_ROLES_URL, {
        count: 1000,
        offset: 0,
        companyId: item.companyId,
      });
      setRolesItems(
        data.list.map((role, index) => {
          return {
            id: role.roleId,
            value: role.name,
          };
        })
      );
    } catch (e) {
      console.log('ERROR', e);
    }
  };
  useEffect(() => {
    setToastParams({
      message: '',
      type: '',
      id: '',
    });
  }, [isAddPopupShown]);

  const onBackClick = () => {
    setIsAddPopupShown(false);
    setIsShowUserDetails(false);
    setToastParams2({
      type2: '',
      message2: '',
      id2: '',
    });
  };

  return (
    // <Modal>

    <>
      {isAddPopupShown && (
        <>
          <UserAddEdit
            item={{ ...userModel }}
            onClose={setIsAddPopupShown.bind(null, false)}
            // eslint-disable-next-line no-sequences
            onBack={onBackClick}
            onSave={addItem}
            type='add'
            roles={rolesItems}
            selected={[]}
          />
          {toastParams.message && (
            <Toast
              type={toastParams.type}
              message={toastParams.message}
              id={toastParams.id}
            />
          )}
        </>
      )}

      {isShowUserDetails && (
        <>
          <UsersList onBack={onBackClick} />
        </>
      )}

      {!isAddPopupShown && !isShowUserDetails && (
        <div style={{ position: 'relative', zIndex: 2, marginTop: '80px' }}>
          {toastParams2.message2 && (
            <Toast
              type={toastParams2.type2}
              message={toastParams2.message2}
              id={toastParams2.id2}
            />
          )}
          <div
            style={{
              boxShadow: '0 5px 10px rgb(0, 0, 0, 0.3)',
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '20px',
              margin: '10px',
              marginTop: isFromCart ? 10 : 0,
              position: 'relative',
              zIndex: 2
            }}
          >
            {!hideCustomers && (
              <div
                className='flex flex-middle c-pointer'
                onClick={() => {
                  if (setRemoveTabs) setRemoveTabs(false);
                  if (onBack) onBack();
                }}
                style={{ 
                  cursor: 'pointer',
                  marginBottom: 20,
                  width: 'fit-content',
                  zIndex: 10,
                  position: 'relative',
                  opacity: 1,
                  visibility: 'visible',
                  display: 'flex'
                }}
              >
                <img 
                  src={CaretIcon} 
                  className='wt-20 rotate-90' 
                  alt="Back" 
                  style={{ 
                    display: 'block',
                    opacity: 0.5,
                    marginRight: '8px'
                  }} 
                />
                <span 
                  className='fs-12 c-table-header fw-bolder' 
                  style={{ 
                    display: 'block',
                    color: '#333'
                  }}
                >
                  Back To Customers
                </span>
              </div>
            )}
            <div
              style={{ marginTop: 0, marginBottom: 20 }}
              className='flex flex-middle'
            >
              {(hierarchy === 10 || hierarchy === 1) &&
                window.location.pathname.includes('settings-config') && (
                  <>
                    <div style={{ marginLeft: 20 }}>
                      <div
                        className='btn ht-40 flex flex-middle flex-between bg-gray pl-8 pr-8 pb-8 pt-8 c-white fw-bolder c-pointer'
                        onClick={() => {
                          setIsShowUserDetails(true);
                        }}
                      >
                        <span>Go To Users</span>
                      </div>
                    </div>
                    <div
                      className='btn ht-40 d-flex  align-items-center bg-gray pl-8 pr-8 pb-8 pt-8 c-white fw-bolder c-pointer'
                      onClick={() => {
                        setIsAddPopupShown(true);
                      }}
                      style={{ marginLeft: '10px' }}
                    >
                      <img src={IconAdd} className='ht-20 wt-20 mr-8' />
                      <span>Create user</span>
                    </div>
                  </>
                )}
            </div>
            <div
              className={`fs-24 fw-bolder c-gray ${
                isMobile ? 'mb-10' : 'mb-40'
              }`}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginTop: 0 }}
            >
              <span>
                {type === 'add'
                  ? window.location.pathname.includes('settings-config')
                    ? 'SETTINGS'
                    : 'CREATE CUSTOMER'
                  : 'EDIT CUSTOMER'}
              </span>
              <div className='flex flex-middle'>
                <div className='flex flex-middle mr-20'>
                  <span className='fs-14 fw-bold c-gray mr-8'>Auto Approved ?</span>
                  <Toggle
                    className='bg-theme'
                    onChange={(e) => {
                      setIsAutoApproved(e.target.checked);
                      setEditIsAutoApproved(e.target.checked);
                    }}
                    checked={isAutoApproved}
                  />
                </div>
                <Button
                  type="secondary"
                  onClick={() => setShowScanner(true)}
                  className="rounded-pill"
                  style={{ 
                    whiteSpace: 'nowrap', 
                    padding: '4px 8px', 
                    fontSize: '11px',
                    height: '28px',
                    lineHeight: '20px',
                    backgroundColor: '#4a90e2',
                    color: 'white',
                    border: 'none',
                    cursor: 'pointer',
                    marginLeft: '20px',
                    minWidth: 'auto',
                    width: 'auto'
                  }}
                >
                  📷 Scan
                </Button>
              </div>
            </div>
            {/* <div className="flex flex-middle flex-center">
                    <ImageUploading onChange={setImage} initialImage={item.companyLogo}/>
                </div> */}

            <div
              className={`flex flex-between flex-middle  flex-wrap ${
                isMobile ? 'flex-column mb-10' : 'mb-40'
              }`}
            >
              {type === 'edit' && !canEditCompanyName ? (
                <div className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}>
                  <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    Company Name
                  </div>
                  <div> {companyName} </div>
                </div>
              ) : (
                <FormInput
                  inputClassName='bg-blue rounded-pill'
                  style={{ paddingLeft: '10px' }}
                  placeholder={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `Company Name <span style='color:red;'>*</span>`,
                      }}
                    ></div>
                  }
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                    setEditCompanyName(e.target.value);
                  }}
                  className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                  value={companyName}
                  hasError={hasSubmitted && !validations.companyName}
                  errorMessage={hasSubmitted && !validations.companyName && companyName ? 'Company Name must be at least 3 characters' : undefined}
                />
              )}
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Primary Contact First Name <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setFirstName(e.target.value);
                  setEditFirstName(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={firstName}
                hasError={hasSubmitted && !validations.firstName}
                errorMessage={hasSubmitted && !validations.firstName && firstName ? 'First Name must be at least 2 characters' : undefined}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Primary Contact Last Name <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setLastName(e.target.value);
                  setEditLastName(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={lastName}
                hasError={hasSubmitted && !validations.lastName}
                errorMessage={hasSubmitted && !validations.lastName && lastName ? 'Last Name must be at least 2 characters' : undefined}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder='Company Email'
                isMandatory={true}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEditEmail(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={email}
                hasError={hasSubmitted && !validations.email}
                errorMessage={hasSubmitted && !validations.email && email ? 'Please enter a valid email address' : undefined}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder='Company Phone'
                onChange={(e) => {
                  setPhone(normalizeInput(e.target.value || ''));
                  setEditPhone(normalizeInput(e.target.value || ''));
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={phone}
                // hasError={hasSubmitted && !validations.phone}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder='Driver License'
                isMandatory={true}
                onChange={(e) => {
                  setDriversLicense(e.target.value);
                  setEditDriversLicense(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={driversLicense}
                hasError={hasSubmitted && !validations.driversLicense}
              />
            </div>
            <div className='flex flex-between flex-middle mb-40 flex-wrap'>
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Company Address 1 <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setAddress(e.target.value);
                  setEditAddress(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={address}
                hasError={hasSubmitted && !validations.address}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder='Company Address 2'
                onChange={(e) => {
                  setAddress1(e.target.value);
                  setEditAddress1(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={address1}
                // hasError={hasSubmitted && !validations.address1}
              />
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Company City <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  setCity(e.target.value);
                  setEditCity(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={city}
                hasError={hasSubmitted && !validations.city}
              />
              <div className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}>
                <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Select Company State <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                </div>
                <select
                  name='type'
                  className='select font-primary fs-14 fw-bolder rounded-pill bg-blue'
                  value={state}
                  onChange={(e) => {
                    setState(e.target.value);
                    setEditState(e.target.value);
                  }}
                >
                  <option value={''}>Select Company State</option>
                  {STATES_LIST.map((state) => {
                    return <option value={state}>{state}</option>;
                  })}
                </select>
                {hasSubmitted && !validations.state && (
                  <div className='fs-10 c-error fw-bold p-absolute'>
                    Please select valid state
                  </div>
                )}
              </div>
              {/*<FormInput  inputClassName="bg-blue rounded-pill"
            style={{ paddingLeft: "10px" }} 
                        placeholder="State"
                        onChange={(e)=> {
                            setState(e.target.value);
                        }}
                        className="mr-40 wt-33p"
                        value={state}
                        hasError={hasSubmitted && !validations.state}

                    />*/}
              <FormInput
                inputClassName='bg-blue rounded-pill'
                style={{ paddingLeft: '10px' }}
                placeholder={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Company Zipcode <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                }
                onChange={(e) => {
                  if (isNaN(e.target.value)) {
                    return;
                  }
                  setZipcode(e.target.value);
                  setEditZipcode(e.target.value);
                }}
                className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                value={(zipcode || '').replace(/[^\d]/g, '')}
                hasError={hasSubmitted && !validations.zipcode}
              />

              {/* <div className='flex flex-between wt-33p mr-40 p-relative t--8'>
                <div>
                            <div className="fs-14 mb-4 fw-bold mt-20 c-gray">Is Partner?</div>
                            <Toggle 
                                className="bg-theme"
                                onChange={(e)=> {
                                    setIsPartner(e.target.checked)
                                }}
                                checked={isPartner}
                            />
                        </div>
                <div className="">
                        <div className="fs-14 mb-4 fw-bold mt-20 c-gray">Is Active?</div>
                            <Toggle 
                                className="bg-theme"
                                onChange={(e)=> {
                                    setIsActive(e.target.checked)
                                }}
                                checked={isActive}
                            />
                        </div>
              </div> */}
              {/* <div className="wt-33p mr-40 p-relative t--8">   
                        
                    </div> */}
              {!hideAbcPricing && shouldShowPriceMod && (
                <div
                  className={`${
                    isMobile ? 'wt-100p' : 'wt-33p mr-40'
                  } p-relative t--8`}
                >
                  <div className='fs-14 mb-4 fw-bold mt-20'>Is ABC Pricing</div>
                  <Toggle
                    className='bg-theme'
                    onChange={(e) => {
                      setPriceMod(e.target.checked);
                      setEditPriceMod(e.target.checked);
                    }}
                    checked={priceMod}
                  />
                </div>
              )}
              <div
                className={`${
                  isMobile ? 'wt-100p mb-2' : 'wt-33p mr-40'
                } p-relative t-12`}
              >
                <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Company Type <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                </div>
                {pathname.includes('/settings-config') ||
                (type === 'edit' && pathname.includes('/viewGroup')) ? (
                  <span className='c-gray ml-4'>{companyType}</span>
                ) : (
                  <select
                    name='type'
                    className='select font-primary fs-14 fw-bolder rounded-pill bg-blue'
                    value={companyType}
                    onChange={(e) => {
                      setEditCompanyType(e.target.value);
                      setCompanyType(e.target.value);
                    }}
                  >
                    <option value={''}>Select Company Type</option>
                    {(hierarchy !== 10 && canCreateFranchise
                      ? COMPANY_TYPES
                      : COMPANY_TYPES_10
                    ).map((type) => {
                      return <option value={type.id}>{type.value}</option>;
                    })}
                  </select>
                )}
                {hasSubmitted && !validations.companyType && (
                  <div className='fs-10 c-error fw-bold p-absolute'>
                    Please select valid Company Type
                  </div>
                )}
                {/* <SelectCheckbox
              isRound={true}
              className="bg-blue rounded-pill"
              id={"companyType-dropdowns"}
              selectPlaceholder={"Company Type"}
              selected={
                companyType
                  ? [
                      {
                        id: companyType,
                        value: COMPANY_TYPES.find((type) => {
                          return type.id === companyType;
                        }).value,
                      },
                    ]
                  : []
              }
              items={COMPANY_TYPES}
              selectSingle={true}
              setSelectedItems={(items) => {
                console.log('ssdv', items)
                hierarchy === 1 && setCompanyType(items[0].id);
              }}
              hasError={hasSubmitted && !validations.companyType}
            /> */}
              </div>
              <div
                className={`${
                  isMobile ? 'wt-100p mb-2' : 'wt-33p mr-40'
                } p-relative t-12`}
              >
                {/* <SelectCheckbox
              id={"selectedFacilities-dropdowns"}
              selectPlaceholder={"Facilities"}
              selected={selectedFacilities || []}
              items={facilities.map((facility) => {
                return {
                  id: facility.facilityId,
                  value: facility.name,
                };
              })}
              setSelectedItems={(items) => {
                console.log("ITEMS", items);
                setSelectedFacilities(items);
              }}
              hasError={hasSubmitted && !validations.companyType}
            /> */}
                <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Select Facility <span style='color:red;'>*</span>`,
                    }}
                  ></div>
                </div>
                {pathname.includes('/settings-config') ? (
                  <span className='c-gray ml-4'>{facility}</span>
                ) : (
                  <select
                    name='type'
                    placeholder='Facilities'
                    className='select font-primary fs-14 fw-bolder rounded-pill bg-blue'
                    value={facility}
                    onChange={(e) => {
                      setFacility(e.target.value);
                      setEditFacility(e.target.value);
                    }}
                  >
                    <option value={''}>Select Facility</option>
                    {facilities.map((facility) => {
                      return (
                        <option value={facility.name}>{facility.name}</option>
                      );
                    })}
                  </select>
                )}

                {hasSubmitted &&
                  !validations.facilities &&
                  companyType != 'FRANCHISE' && (
                    <div className='fs-10 c-error fw-bold p-absolute'>
                      Please select valid Facility
                    </div>
                  )}
              </div>
              {canShowPriceModifier &&
              pathname.includes('/settings-config') &&
              hierarchy !== 1 ? (
                ''
              ) : (
                <div
                  className={`${
                    isMobile ? 'wt-100p mb-2' : 'wt-33p mr-40'
                  } p-relative t--8`}
                >
                  <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                    Price Modifier
                  </div>
                  <div className='flex flex-middle'>
                    <div className='flex flex-middle mr-16'>
                      <span className='c-gray mr-4'>%</span>
                      <Toggle
                        className='bg-theme hide-check-cross'
                        onChange={(e) => {
                          setEditIsPriceModifierPercantage(e.target.checked);
                          if (pathname.includes('/settings-config')) {
                            return;
                          }
                          e.target.checked
                            ? setIsPriceModifierPercantage(false)
                            : setIsPriceModifierPercantage(true);
                        }}
                        checked={!isPriceModifierPercantage}
                      />
                      <span className='c-gray ml-4'>$</span>
                    </div>
                    <FormInput
                      inputClassName='bg-blue rounded-pill'
                      style={{ paddingLeft: '10px' }}
                      className='wt-150'
                      type='number'
                      step='0.01'
                      value={modifierInputValue}
                      onChange={(e) => {
                        if (pathname.includes('/settings-config')) {
                          return;
                        }
                        setModifierInputValue(e.target.value);
                        setEditModifierInputValue(e.target.value);
                      }}
                    />
                    {/* <div className="flex flex-middle fs-18 wt-30  bg-white">{isPriceModifierPercantage ? "%" : "$"}</div> */}
                  </div>
                </div>
              )}

              {!canShowPriceModifier && (
                <div className='mr-40 wt-33p p-relative'></div>
              )}

              <div className={`${isMobile ? 'wt-100p mb-2' : 'wt-33p mr-40'}`}>
                <div className='fs-14 mb-4 fw-bold c-gray'> Company Logo </div>
                <div className='flex flex-middle'>
                  <ImageUploading
                    onChange={setImage}
                    initialImage={item.companyLogo}
                  />
                </div>
              </div>

              {hasSubmitted && !image && companyType === 'FRANCHISE' && (
                <div className='fs-10 c-error fw-bold p-absolute'>
                  please add image
                </div>
              )}

              <div className='flex flex-between flex-middle mb-40 flex-wrap wt-100p'>
                <FormInput
                  inputClassName='bg-blue rounded-pill'
                  style={{ paddingLeft: '10px' }}
                  placeholder='Business License'
                  onChange={(e) => {
                    setBusinessLicense(e.target.value);
                    setEditBusinessLicense(e.target.value);
                  }}
                  className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                  value={businessLicense}
                  // hasError={hasSubmitted && !validations.businessLicense}
                />
                <FormInput
                  inputClassName='bg-blue rounded-pill'
                  style={{ paddingLeft: '10px' }}
                  placeholder='EIN'
                  onChange={(e) => {
                    setEin(e.target.value);
                    setEditEin(e.target.value);
                  }}
                  className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}
                  value={ein}
                  // hasError={hasSubmitted && !validations.ein}
                />
                <div className={`${!isMobile ? 'wt-33p mr-40' : 'wt-100p'}`}>
                  <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                    Metal Recycler License
                  </div>
                  <ImageUploading
                    onChange={setMetalLicense}
                    initialImage={metalLicense}
                  />
                </div>
              </div>

              {hierarchy === 1 && canAdjustCustomerSettings && (
                <div
                  className={`flex flex-between flex-middle mb-40 flex-wrap wt-100p ${
                    isMobile ? 'flex-column' : ''
                  }`}
                >
                  <div
                    className={` ${
                      isMobile ? 'wt-100p' : 'wt-20p mr-10'
                    }  p-relative`}
                  >
                    <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                      Is Picture Mandatory?
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setIsPictureMandatory(e.target.checked);
                        setEditIsPictureMandatory(e.target.checked);
                      }}
                      checked={isPictureMandatory}
                    />
                  </div>
                  <div
                    className={` ${
                      isMobile ? 'wt-100p' : 'wt-20p mr-10'
                    }  p-relative`}
                  >
                    <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                      Can See Offer Price?
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setCanSeeUnitPrice(e.target.checked);
                        setEditCanSeeUnitPrice(e.target.checked);
                      }}
                      checked={canSeeUnitPrice}
                    />
                  </div>
                  <div
                    className={` ${
                      isMobile ? 'wt-100p' : 'wt-20p mr-10'
                    }  p-relative`}
                  >
                    <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                      Can See Markup?
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setCanSeeMarkup(e.target.checked);
                        setEditCanSeeMarkup(e.target.checked);
                      }}
                      checked={canSeeMarkup}
                    />
                  </div>
                  <div
                    className={` ${
                      isMobile ? 'wt-100p' : 'wt-20p mr-10'
                    }  p-relative`}
                  >
                    <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                      Can See Subtotal ?
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setCanSeeSubtotal(e.target.checked);
                        setEditCanSeeSubtotal(e.target.checked);
                      }}
                      checked={canSeeSubtotal}
                    />
                  </div>
                  <div
                    className={` ${
                      isMobile ? 'wt-100p' : 'wt-20p mr-10'
                    }  p-relative`}
                  >
                    <div className='fs-14 mb-4 fw-bold mt-20 c-gray'>
                      Can Build Cart ?
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setCanBuildCart(e.target.checked);
                        setEditCanBuildCart(e.target.checked);
                      }}
                      checked={canBuildCart}
                    />
                  </div>
                </div>
              )}
              {/* {hierarchy === 1 && canSeeLookupRestrictions && (
                <>
                  <div
                    className={`${
                      isMobile ? 'wt-100p mb-2' : 'wt-25p mr-40'
                    } p-relative t-12`}
                  >
                    <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `Lookup Restrictions`,
                        }}
                      ></div>
                    </div>
                    <input
                      type='number'
                      name='lookupRestrictions'
                      placeholder='Enter value (1-10000)'
                      className='input font-primary fs-14 fw-bolder rounded-pill bg-blue wt-100p'
                      style={{ paddingLeft: '10px', paddingRight: '10px' }}
                      min='1'
                      max='10000'
                      step='1'
                      value={lookupRestrictions}
                      onChange={(e) => {
                        const value = e.target.value;
                        const numValue = Number(value);
                        // Allow empty string or valid integers between 1 and 10000
                        if (value === '') {
                          setLookupRestrictions('');
                        } else if (!isNaN(numValue) && Number.isInteger(numValue) && numValue >= 1 && numValue <= 10000) {
                          setLookupRestrictions(value);
                        }
                      }}
                      onBlur={(e) => {
                        const value = e.target.value;
                        const numValue = Number(value);
                        // Clear if value is out of range on blur
                        if (value && (isNaN(numValue) || !Number.isInteger(numValue) || numValue < 1 || numValue > 10000)) {
                          setLookupRestrictions('');
                        }
                      }}
                    />
                  </div>
                  <div
                    className={`${
                      isMobile ? 'wt-100p mb-2' : 'wt-25p mr-40'
                    } p-relative t-12`}
                  >
                    <div className={`c-gray fs-14 ${isMobile ? 'mb-2' : 'mb-4'}`}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `Unlimited Credits ?`,
                        }}
                      ></div>
                    </div>
                    <Toggle
                      className='bg-theme'
                      onChange={(e) => {
                        setIsCreditUnlimited(e.target.checked);
                        setEditIsCreditUnlimited(e.target.checked);
                      }}
                      checked={type === 'edit' ? (editIsCreditUnlimited !== undefined ? editIsCreditUnlimited : isCreditUnlimited) : isCreditUnlimited}
                    />
                  </div>
                </>
              )} */}
              {/* <div className='wt-33p mr-40 p-relative'></div>
              <div className='wt-33p mr-40 p-relative'></div>
              <div className='wt-33p mr-40 p-relative'></div>
              <div className='wt-33p mr-40 p-relative'></div> */}
            </div>
            <div className='flex flex-middle flex-right'>
              <Button
                className='flex  ht-40 flex-middle mr-20 btn btn-red'
                type='modalCancel'
                onClick={() => {
                  setRemoveTabs(false);
                  onClose();
                }}
              >
                {/*<img src={DeleteIcon} className="wt-20 ht-20 mr-4"/>*/}
                <span>CANCEL</span>
              </Button>

              <Button
                type='modalSave'
                className='btn  ht-40'
                onClick={() => {
                  if (isLoading) {
                    return;
                  }
                  setHasSubmitted(true);
                  const updatedValidations = validateFields();
                  if (
                    !updatedValidations.companyName ||
                    (companyType !== 'FRANCHISE' &&
                      !updatedValidations.facility) ||
                    !updatedValidations.address ||
                    // !updatedValidations.address1 ||
                    !updatedValidations.city ||
                    !updatedValidations.state ||
                    !updatedValidations.zipcode ||
                    !updatedValidations.firstName ||
                    !updatedValidations.lastName ||
                    !updatedValidations.email ||
                    !updatedValidations.driversLicense
                  ) {
                    setRemoveTabs(true);
                    // Scroll to first error field
                    setTimeout(() => {
                      // Find first field with error class in DOM order
                      const errorFields = document.querySelectorAll('.forminput-wrap.has-error');
                      if (errorFields.length > 0) {
                        errorFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                      } else {
                        // Fallback: scroll to top
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                    }, 100);
                    return; // Stop execution if validation fails
                  }
                  
                  setRemoveTabs(false);

                  onSave(
                    {
                      companyName:
                        type === 'edit' ? companyEditName : companyName,
                      companyType: !pathname.includes('/viewGroup')
                        ? companyType
                        : type === 'edit'
                        ? editCompanyType
                        : companyType,
                      address: type === 'edit' ? editAddress : address,
                      address1: type === 'edit' ? editAddress1 : address1,
                      phone: type === 'edit' ? editPhone : phone,
                      city: type === 'edit' ? editCity : city,
                      state: type === 'edit' ? editState : state,
                      zipcode: type === 'edit' ? editZipcode : zipcode,
                      email: type === 'edit' ? editEmail : email,
                      firstName: type === 'edit' ? editFirstName : firstName,
                      lastName: type === 'edit' ? editLastName : lastName,
                      companyId: item.companyId,
                      companyLogo: item.companyLogo,
                      isPartner: type === 'edit' ? undefined : isPartner,
                      isActive: type === 'edit' ? undefined : isActive,
                      isPictureMandatory:
                        type === 'edit'
                          ? editIsPictureMandatory
                          : isPictureMandatory,
                      canSeeUnitPrice:
                        type === 'edit' ? editCanSeeUnitPrice : canSeeUnitPrice,
                      canSeeMarkup:
                        type === 'edit' ? editCanSeeMarkup : canSeeMarkup,
                      canSeeSubtotal:
                        type === 'edit' ? editCanSeeSubtotal : canSeeSubtotal,
                      businessLicense:
                        type === 'edit' ? editBusinessLicense : businessLicense,
                      canBuildCart:
                        type === 'edit' ? editCanBuildCart : canBuildCart,
                      isAutoApproved:
                        type === 'edit'
                          ? editIsAutoApproved !== undefined
                            ? editIsAutoApproved
                            : isAutoApproved
                          : isAutoApproved,
                      driversLicense:
                        type === 'edit' ? editDriversLicense : driversLicense,
                      // metalLicense,
                      ein: type === 'edit' ? editEin : ein,
                      priceMod:
                        type === 'edit'
                          ? editPriceMod
                          : shouldShowPriceMod
                          ? priceMod
                          : undefined,
                      facility: type === 'edit' ? editfacility : facility,
                      groupModifierIsPercentage:
                        type === 'edit'
                          ? editIsPriceModifierPercantage
                          : isPriceModifierPercantage,
                      groupModifier:
                        type === 'edit'
                          ? editModifierInputValue
                          : modifierInputValue,
                      isFacility:
                        companyType == 'Franchise' ? 'true' : undefined,
                      lookupRestriction: lookupRestrictions ? parseInt(lookupRestrictions) : null,
                      isCreditUnlimited: type === 'edit' ? (editIsCreditUnlimited !== undefined ? editIsCreditUnlimited : isCreditUnlimited) : isCreditUnlimited,
                    },
                    image ? image[0] : null,
                    metalLicense ? metalLicense[0] : null
                  );
                }}
              >
                {/* {type === 'add' ? 'Add' : 'Edit'} item */}
                <img src={Tick} className='wt-20 ht-20 mr-4' />
                <span>{isLoading ? 'Loading...' : 'SAVE'}</span>
              </Button>
            </div>
          </div>
        </div>
      )}

      {showScanner && (
        <DriverLicenseScanner
          onScanComplete={(parsedData) => {
            // Auto-fill form fields from scanned data
            if (parsedData.firstName) {
              setFirstName(parsedData.firstName);
              if (type === 'edit') {
                setEditFirstName(parsedData.firstName);
              }
            }
            if (parsedData.lastName) {
              setLastName(parsedData.lastName);
              if (type === 'edit') {
                setEditLastName(parsedData.lastName);
              }
            }
            if (parsedData.driversLicense) {
              console.log('Setting driver license:', parsedData.driversLicense);
              setDriversLicense(parsedData.driversLicense);
              if (type === 'edit') {
                setEditDriversLicense(parsedData.driversLicense);
              }
            } else {
              console.warn('No driver license number found in parsed data:', parsedData);
            }
            if (parsedData.address) {
              setAddress(parsedData.address);
              if (type === 'edit') {
                setEditAddress(parsedData.address);
              }
            }
            if (parsedData.city) {
              setCity(parsedData.city);
              if (type === 'edit') {
                setEditCity(parsedData.city);
              }
            }
            if (parsedData.state) {
              // State abbreviation to full name mapping
              const stateAbbrMap = {
                'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
                'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
                'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
                'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
                'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
                'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
                'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
                'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
                'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
                'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
                'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
                'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
                'WI': 'Wisconsin', 'WY': 'Wyoming'
              };
              
              const stateValue = parsedData.state.toUpperCase().trim();
              // Check if it's already in STATES_LIST format
              let finalState = STATES_LIST.find(s => s.toUpperCase() === stateValue || s === parsedData.state);
              
              // If not found, try abbreviation mapping
              if (!finalState && stateAbbrMap[stateValue]) {
                finalState = stateAbbrMap[stateValue];
              }
              
              // If still not found, try to find by first 2 letters
              if (!finalState) {
                finalState = STATES_LIST.find(s => s.toUpperCase().substring(0, 2) === stateValue);
              }
              
              if (finalState) {
                setState(finalState);
                if (type === 'edit') {
                  setEditState(finalState);
                }
              } else {
                // Fallback: use the value as-is
                setState(stateValue);
                if (type === 'edit') {
                  setEditState(stateValue);
                }
              }
            }
            if (parsedData.zipcode) {
              setZipcode(parsedData.zipcode);
              if (type === 'edit') {
                setEditZipcode(parsedData.zipcode);
              }
            }
            setShowScanner(false);
          }}
          onClose={() => setShowScanner(false)}
        />
      )}
    </>

    // </Modal>
  );
};

export default EntityAddEdit;
